import { useState, useEffect, useCallback, useRef } from 'react';
import { useParams } from 'react-router-dom';

import printJS from 'print-js';

import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Card, CardContent } from "@material-ui/core";

import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutline';
import AddIcon from '@material-ui/icons/Add';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';


import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Typography from '@material-ui/core/Typography';
import { AplicarLegenda } from '../Caixa/Style';

import Table from '@base/Table';
import Toast from '@base/Toast';
import Dialog from '@base/Dialog';
import DialogRemove from '@base/Dialog/DialogRemove';
import ButtonPrimary from '@base/Button';
import { ButtonCancel, ButtonSave } from '@base/Button/ButtonForm';
import Title from '@base/Title';
import Filters from '@base/Filter';
import TextField from '@base/Inputs/Text';
import Boolean from '@base/Inputs/Boolean';
import {
	verifyPagingAndSorting,
	PAGE,
	SIZE,
	ASC,
	TOTAL_ELEMENTS,
	TOTAL_PAGES,
} from '@base/Table/Utils';

import TipoPendenciaService from '@services/TipoPendenciaService';

import { removePagingAndSorting } from '@helpers/PaginationHelper';
import { ProcessoResolver } from "@helpers/ProcessoHelper";

export const TipoPendencia = () => {

	const [loading, setLoading] = useState(true);
	const [openDialog, setOpenDialog] = useState(false);
	const [openDialogEditarOpcao, setOpenDialogEditarOpcao] = useState(false);

	const [idExcluir, setIdExcluir] = useState();
	const [openDialogRemove, setOpenDialogRemove] = useState(false);

	const [list, setList] = useState([]);

	const [page, setPage] = useState(PAGE);
	const [size, setSize] = useState(SIZE);
	const [defaultOrderBy,] = useState('descricao');
	const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
	const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
	const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

	const [editarOpcaoSelecionadaId, setEditarOpcaoSelecionadaId] = useState();
	const [editarOpcaoSelecionadaDescricao, setEditarOpcaoSelecionadaDescricao] = useState();

	const [id, setId] = useState();
	const [descricao, setDescricao] = useState();
	const [enviaEmail, setEnviaEmail] = useState(false);

	const [remetente, setRemetente] = useState();
	const [responderPara, setResponderPara] = useState();
	const [assunto, setAssunto] = useState();
	const [mensagem, setMensagem] = useState();

	const [, setPergunta] = useState();
	const [, setTipoResposta] = useState();
	const [respostasCriadas, setRespostasCriadas] = useState([]);
	const [, setRespostaSelecionada] = useState();
	const [, setNovaResposta] = useState();

	const [focoBotaoFiltrar, setFocoBotaoFiltrar] = useState(true);
	const [filtros, setFiltros] = useState([]);
	const [filtroAtivo, setFiltroAtivo] = useState(false);
	const [filtroDescricao, setFiltroDescricao] = useState();
	const [filtroEnviaEmail, setFiltroEnviaEmail] = useState('');
	const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

	const pageName = 'Tipos de Pendências';

	const params = useParams();
	const processo = ProcessoResolver(params.processo);

	const toastRef = useRef(null);

	const aplicarFiltros = (ativo = false) => {
		let f = [];

		if (filtroDescricao) f.push({ field: 'descricao', value: filtroDescricao });
		if (filtroEnviaEmail) f.push({ field: 'enviaEmail', value: filtroEnviaEmail });

		setFiltros(f);
		setFiltroAtivo(ativo);
		setQuantidadeFiltrosAplicados(f.length);
	}

	const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

	const limparFiltros = () => {
		setSort([{ orderBy: defaultOrderBy, order: ASC }]);
		setPage(PAGE);
		setSize(SIZE);
		setFiltros([]);
		setFiltroAtivo(false);
		setFiltroDescricao('');
		setFiltroEnviaEmail('');
		setQuantidadeFiltrosAplicados(0);
	}

	const handleChangeEditor = editor => setMensagem(editor.getData());

	const buttonAdd = () =>
		<Grid container spacing={3} >
			<Grid item xs={12} >
				<ButtonPrimary
					disabled={loading}
					onClick={() => {
						setOpenDialog(true);
						setFocoBotaoFiltrar(false);
					}}
					name="Adicionar Novo Tipo de Pendência"
					startIcon={<AddIcon />}
				/>
			</Grid>
		</Grid>

	const buttonsSubmit = () =>
		<>
			<ButtonSave
				onClick={() => {
					setLoading(true);
					submit();
				}}
				startIcon={loading ? <CircularProgress size={16} /> : <CheckOutlinedIcon />}
			/>
			<ButtonCancel onBack={fecharModal} />
		</>

	const submit = () => {
		const pendencia = {
			id: id,
			descricao: descricao,
			configuracaoEnvioEmail: {
				seEnviaEmail: enviaEmail,
				assunto: assunto,
				de: remetente,
				responderPara: responderPara,
				mensagem: mensagem
			},
		}

		if(!((descricao)) || ((enviaEmail) && !((assunto) && (remetente) && (responderPara) && (mensagem)))) {
			toastRef.current.show("error", "Preencha todos os campos com asterisco!");
		} else {

			if(id) {

				TipoPendenciaService.editar(processo.id, id, pendencia).then(resultado => {
					toastRef.current.show("success", "Tipo de Pendência Salva com Sucesso!");
					setOpenDialog(false);
					carregarDados();
					setLoading(false);
				}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Editar o Tipo de Pendência!"));

			} else {

				TipoPendenciaService.adicionar(processo.id, pendencia).then(resultado => {
					toastRef.current.show("success", "Tipo de Pendência Salva com Sucesso!");
					setOpenDialog(false);
					carregarDados();
					setLoading(false);
				}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Criar um Novo Tipo de Pendência!"));

			}

			setId('');
			setDescricao('');
			setEnviaEmail(false);
			setRemetente('');
			setResponderPara('');
			setAssunto('');
			setMensagem('');
			setPergunta('');
			setTipoResposta('');
			setRespostaSelecionada('');
			setRespostasCriadas([]);
			setNovaResposta('');

		}

	};

	const submitExcluir = (id, setLoading) => {
		TipoPendenciaService.excluir(processo.id, id).then(resultado => {
			toastRef.current.show("success", "Tipo de Pendência Removida com Sucesso!");
			setOpenDialogRemove(false);
		}).catch(error => {
			toastRef.current.show("error", "Não foi possível excluir Tipo Pendência: " + error.response.data.mensagens.map(mensagem => mensagem).join(" ,"));
		}).finally(() => {
			fecharModalExcluir();
			setLoading(false);
		});
	};

	const abrirModalExclusao = (id) => {
		setOpenDialogRemove(true);
		setIdExcluir(id);
	}

	const tituloModalExclusao = () => `Excluir Tipo de Pendência`;

	const textoExcluir = () => ``;

	/*const abrirModalEditarOpcao = (resposta) => {
		setEditarOpcaoSelecionadaId(resposta.id);
		setEditarOpcaoSelecionadaDescricao(resposta.descricao);
		setOpenDialogEditarOpcao(true);
	}*/

	const salvarEdicaoOpcao = (resposta) => {

		if(editarOpcaoSelecionadaDescricao){

			let respostas = respostasCriadas.map(resposta => {
				if(resposta.id === editarOpcaoSelecionadaId){
					resposta.descricao = editarOpcaoSelecionadaDescricao;
				}
				return resposta;
			});

			setEditarOpcaoSelecionadaId(undefined);
			setEditarOpcaoSelecionadaDescricao(undefined);
			setRespostasCriadas(respostas);
			setOpenDialogEditarOpcao(false);

			toastRef.current.show("success", "Opção atualizada com sucesso!")

		}else{
			toastRef.current.show("error", "O campo descrição é obrigatório!")
		}

	}

	const fecharModalExcluir = () => {
		setOpenDialogRemove(false);
		setIdExcluir();

		carregarDados();
	}

	const abrirModal = (id) => {
		TipoPendenciaService.listarUm(processo.id, id).then(resultado => {
			const { id, descricao, configuracaoEnvioEmail } = resultado.data;

			setId(id);
			setDescricao(descricao);
			setEnviaEmail(configuracaoEnvioEmail.seEnviaEmail);

			setRemetente(configuracaoEnvioEmail.de);
			setResponderPara(configuracaoEnvioEmail.responderPara);
			setAssunto(configuracaoEnvioEmail.assunto);
			setMensagem(configuracaoEnvioEmail.mensagem);

			setOpenDialog(true);
			setFocoBotaoFiltrar(false);
		}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar o Tipo de Pendência!"));
	}

	const imprimirEtiquetaTipoPendencia = (id) => {

		console.log(id);
		setLoading(true);

		TipoPendenciaService.imprimirEtiqueta(processo.id, id).then(etiqueta => {
			let blob = new Blob([etiqueta.data], { type: etiqueta.data.type });
			let fileURL = URL.createObjectURL(blob);
			printJS({
				printable: fileURL,
				type: "pdf",
				showModal: "true",
				modalMessage: 'Imprimindo etiqueta Tipo de Pendência...'
			});
		}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao imprimir etiqueta Tipo de Pendência."))
		.finally(() => setLoading(false));

	};

	const tituloModal = () => `${id ? "Editar" : "Adicionar Novo"} Tipo de Pendência`;

	const fecharModal = (event, reason) => {
		if (reason === "backdropClick") {
			return false;
		}

		setOpenDialog(false);
		setFocoBotaoFiltrar(true);

		setId('');
		setDescricao('');
		setEnviaEmail(false);

		setRemetente('');
		setResponderPara('');
		setAssunto('');
		setMensagem('');

		setPergunta('');
		setTipoResposta('');
		setRespostaSelecionada('');
		setRespostasCriadas([]);
		setNovaResposta('')

		carregarDados();
	};

	const columns = [
		{label: 'ID', name: 'id', func: null, key: true},
		{label: 'Nome', name: 'descricao', func: null, key: false},
		{label: 'Envia Email?', name: 'seEnviaEmail', func: null, key: false, ordering: false},
	];

	const actions = [
		{
			name: () => "Editar Pendência",
			func: abrirModal,
			icon: <EditOutlinedIcon />,
			disabled: () => false,
		},
		{
			name: () => "Imprimir Etiqueta",
			func: imprimirEtiquetaTipoPendencia,
			icon: <PrintOutlinedIcon />,
			disabled: () => false
		},
		{
			name: () => "Excluir Pendência",
			func: abrirModalExclusao,
			icon: <DeleteOutlinedIcon />,
			disabled: () => false,
			color: 'secondary'
		}
	];

	const carregarDados = useCallback(() => {
		const f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, sort, filtroAtivo);

		TipoPendenciaService.filtrar(processo.id, f).then(resultado => {
			const { content, number, size, totalElements, totalPages } = resultado.data;

			const result = content.map(function(a) {
				return {
					id: a.id, descricao: a.descricao,
					seEnviaEmail: a.configuracaoEnvioEmail.seEnviaEmail ? "Sim" : "Não",
				};
			});
			setList(result);
			setPage(number);
			setSize(size);
			setTotalElements(totalElements);
			setTotalPages(totalPages);
			setLoading(false);
		}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar Filtros!"));

	}, [filtros, filtroAtivo, page, size, sort, processo.id]);

	const handlePage = page => { setPage(page); setFiltroAtivo(true); };
	const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroAtivo(true); };
	const verifyOrderBy = (orderBy) => orderBy === 'seEnviaEmail' ? 'tipoPendenciaConfiguracaoEmail.enviaEmailParaEscola' : orderBy;
	const handleSort = (orderBy, order) => {
		if (sort.find(s => s.orderBy === verifyOrderBy(orderBy))) {
			let newSort = sort.filter(s => s.orderBy !== verifyOrderBy(orderBy));
			newSort.splice(sort.indexOf(sort.find(s => s.orderBy === verifyOrderBy(orderBy))), 0, { orderBy: verifyOrderBy(orderBy), order: order })
			setSort([...newSort]);
		} else {
			setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)), { orderBy: verifyOrderBy(orderBy), order: order }]);
		}
		setFiltroAtivo(true);
	}
	const handleClearSort = (orderBy) => { setFiltroAtivo(true); orderBy ? setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy))]) : setSort([{ orderBy: defaultOrderBy, order: ASC }]) };
	const handleTotalPages = () => totalPages;
	const handleTotalElements = () => totalElements;

	useEffect(() => carregarDados(), [carregarDados]);

	const renderizaCamposEmail = () =>
		<Card style={{ marginBottom: 15 }}>
			<CardContent style={{ fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
				Configurações de Email
			</CardContent>
			<CardContent>
				<Grid container spacing={3}>
					<Grid item lg={6}>
						<TextField
							label='Remetente'
							required
							value={remetente}
							name="remetente"
							autoComplete="off"
							onChange={(e) => setRemetente(e.target.value)}
						/>
					</Grid>

					<Grid item lg={6}>
						<TextField
							label={"Responder Para"}
							required
							value={responderPara}
							name="responderPara"
							autoComplete="off"
							onChange={(e) => setResponderPara(e.target.value)}
						/>
					</Grid>
				</Grid>

				<Grid container spacing={3}>
					<Grid item lg={12}>
						<div style={{backgroundColor:"#eee",padding:10,borderRadius:5,fontSize:13}}>
						<span style={{display:"block",fontSize:14}}>Tags Disponíveis</span>
						<AplicarLegenda params={["@escola.nome@"]} />
						<AplicarLegenda params={["@escola.email@"]} />
						<AplicarLegenda params={["@escola.inep@"]} />
						<span style={{display:"block",fontSize:11,marginTop:10}}>Ao utilizar tags elas serão substituídas dinâmicamente pelo valor correspondente no e-mail enviado.</span>
						</div>
					</Grid>
				</Grid>

				<Grid container spacing={3}>
					<Grid item lg={12}>
						<TextField
							label='Assunto'
							required
							value={assunto}
							name="assunto"
							autoComplete="off"
							onChange={(e) => setAssunto(e.target.value)}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={3}>
					<Grid item lg={12}>

						<Typography variant="body2" display="inline" style={{ paddingTop: 8, fontSize: 12, color: 'rgba(0, 0, 0, 0.54)' }}>
							Mensagem <sup>*</sup> &nbsp;
						</Typography>
						<CKEditor
							editor={ ClassicEditor }
							data={mensagem}
							config={{
								toolbar: [],
								language: 'pt-br',
							}}
							onChange={(event, editor) => handleChangeEditor(editor)}
						/>

					</Grid>
				</Grid>
			</CardContent>
		</Card>


	return (
		<>
			<Toast ref={toastRef} />

			<Title>{pageName}</Title>
			<br />
			<Filters
				handleFilter={aplicarFiltros}
				handleFilterClear={limparFiltros}
				countFilters={contarFiltrosAplicados}
				hasFocusButtonFilter={focoBotaoFiltrar}
			>
				<Grid item container spacing={3}>
					<Grid item sm={12} lg={4}>
						<TextField
							label='Tipo de Pendência'
							value={filtroDescricao}
							name='filtroDescricao'
							onChange={(e) => setFiltroDescricao(e.target.value)}
						/>
					</Grid>
					<Grid item sm={12} lg={3}>
						<Boolean
							label={"Envia Email?"}
							value={filtroEnviaEmail}
							name='filtroEnviaEmail'
							onChange={(e) => setFiltroEnviaEmail(e.target.value)}
						/>
					</Grid>
				</Grid>
			</Filters>

			<Table
				columns={columns}
				tableData={list}
				actions={actions}
				page={page}
				handlePage={handlePage}
				handleTotalPages={handleTotalPages}
				handleTotalElements={handleTotalElements}
				rowsPerPage={size}
				handleRowsPerPage={handleRowsPerPage}
				sort={sort}
				handleSort={handleSort}
				handleClearSort={handleClearSort}
				loading={loading}
			/>

			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={() => setOpenDialogEditarOpcao(false)}
				openDialog={openDialogEditarOpcao}
				title={"Editar Opção"}
				actions={[<>
			<ButtonSave onClick={salvarEdicaoOpcao} />
		</>]}
			>
				<Grid container spacing={3}>
					<Grid item lg={12}>
						<TextField
							label='Descrição'
							required
							value={editarOpcaoSelecionadaDescricao}
							name="descricaoEditarOpcao"
							autoComplete="off"
							onChange={(e) => setEditarOpcaoSelecionadaDescricao(e.target.value)}
						/>

					</Grid>
				</Grid>
			</Dialog>

			<Dialog
				maxWidth={"lg"}
				fullWidth={true}
				closeDialog={fecharModal}
				openDialog={openDialog}
				title={tituloModal()}
				actions={buttonsSubmit()}
			>
				<Grid container spacing={3}>
					<Grid item lg={6}>
						<TextField
							label='Tipo de Pendência'
							required
							value={descricao}
							name="descricao"
							autoComplete="off"
							onChange={(e) => setDescricao(e.target.value)}
						/>
					</Grid>

					<Grid item lg={3}>
						<Boolean
							label={"Envia Email?"}
							required
							hiddenblank="true"
							value={enviaEmail}
							name="enviaEmail"
							onChange={(e) => setEnviaEmail(e.target.value === "true" ? true : false)}
						/>
					</Grid>

				</Grid>

				{enviaEmail === true && renderizaCamposEmail()}

			</Dialog>

			{buttonAdd()}

			<DialogRemove
				maxWidth={"sm"}
				id={idExcluir}
				text={textoExcluir()}
				close={fecharModalExcluir}
				open={openDialogRemove}
				title={tituloModalExclusao()}
				handleConfirm={submitExcluir}
			/>
		</>
	);
}

export default TipoPendencia;
